import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import image1 from './images/rocks/one.png'
import image2 from './images/rocks/two.png'
import image3 from './images/rocks/three.png'
import image4 from './images/rocks/four.png'
import image5 from './images/rocks/five.png'
import image6 from './images/rocks/six.png'
import './menu.css'
import NavigationBar from './nav';
import NewNav from './canvas';
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from 'react';

function Rocks() {
  const products=[
    {id:1,name:"Chilled Americano",image:image1},
    {id:2,name:"Sparkling Cold Brew",image:image2},
    {id:3,name:"Iced Cold Brew",image:image3},
    {id:4,name:"Iced Tonic Cold Brew",image:image4},
    {id:5,name:"Cranberry Cold Brew",image:image5},
    {id:6,name:"Espresso King",image:image6},
  ]
    useEffect(()=>{
        Aos.init({duration:"1000"})
      })
  return (
    <>
        <Container fluid>
              <Row>
              <NavigationBar/>
              <NewNav/>
                <Col id='rockTop'>  
                <Row>
                  <Col id='rockHeading'>
                  <p data-aos="zoom-in">Cold Brew</p>
                  </Col>
                </Row>
                </Col>
              </Row>
            </Container>
            <Container>
        <Row>
          <Col md={12} style={{justifyContent: "center",gap: "20px"}}>
            <Row>
              {products.map((p)=>(
              <Col xs={3} md={3} key={products.id} style={{ marginTop: "20px",textAlign:"center",gap:"20px"}}>
                <Card data-aos="zoom-in" style={{border:"none"}}>
                  <Card.Img id='CardImg' 
                  src={p.image} />
                  <Card.Body style={{padding:"5px 0px"}}>
                    <Card.Title id='cardName'>{p.name}</Card.Title>
                  </Card.Body>
                </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
        </Container>
    </>
  )
}

export default Rocks